import _extends from "@babel/runtime/helpers/extends";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _typeof from "@babel/runtime/helpers/typeof";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

import * as React from "react";

var IconEmptyPic = /*#__PURE__*/function (_React$Component) {
  _inherits(IconEmptyPic, _React$Component);

  var _super = _createSuper(IconEmptyPic);

  function IconEmptyPic(props) {
    _classCallCheck(this, IconEmptyPic);

    return _super.call(this, props);
  }

  _createClass(IconEmptyPic, [{
    key: "render",
    value: function render() {
      var isServerRendering = function () {
        try {
          return !((typeof window === "undefined" ? "undefined" : _typeof(window)) !== undefined && document !== undefined);
        } catch (e) {
          return true;
        }
      }();

      var prefixCls = !isServerRendering && window.ARCO_PREFIXCLS ? window.ARCO_PREFIXCLS : this.props.prefixCls;
      var className = this.props && this.props.className ? this.props.className + " " : "";

      var props = _objectSpread(_objectSpread({}, this.props), {}, {
        className: className + "i18n-ecom-alliance-icon arco-icon  arco-icon-fill-none arco-icon-empty-pic".replace(/arco-/g, prefixCls + "-")
      });

      if (this.props.spin) {
        props.className = props.className + " " + prefixCls + "-icon-loading";
      }

      delete props.prefixCls;
      delete props.spin;
      delete props.isIcon;
      return /*#__PURE__*/React.createElement("svg", _extends({
        width: "1em",
        height: "1em",
        viewBox: "0 0 200 200",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        className: "i18n-ecom-alliance-icon arco-icon  arco-icon-fill-none arco-icon-empty-pic"
      }, props), /*#__PURE__*/React.createElement("path", {
        opacity: 0.01,
        fill: "#D8D8D8",
        d: "M0 0h200v200H0z"
      }), /*#__PURE__*/React.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M156.3 34.702a2.7 2.7 0 11-5.401 0 2.7 2.7 0 015.401 0z",
        fill: "#00D4B5"
      }), /*#__PURE__*/React.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M27.406 158.318a4.232 4.232 0 11-8.466 0 4.232 4.232 0 018.466 0zM154.258 182.812a2.97 2.97 0 111.298-5.797 2.971 2.971 0 01-1.298 5.797z",
        fill: "#FFC500"
      }), /*#__PURE__*/React.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M176.852 158.094l1.742-2.221a8.046 8.046 0 00-1.365-11.298l-40.912-32.07a8.044 8.044 0 00-11.292 1.366l-1.743 2.221a8.046 8.046 0 001.366 11.298l40.911 32.07a8.045 8.045 0 0011.293-1.366z",
        fill: "#FFE4DB"
      }), /*#__PURE__*/React.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M163.057 133.449l-3.985-3.124-16.705 10.936 8.526 6.684 12.164-14.496z",
        fill: "#FCC8BD"
      }), /*#__PURE__*/React.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M19.17 126.553l-.001-.003a7.158 7.158 0 015.399-8.793l46.039-10.341c3.984-.895 8.027 1.587 9.031 5.545l.001.004c1.005 3.96-.26 10.781-4.246 11.677l-47.192 7.457c-3.984.894-8.027-1.588-9.031-5.546z",
        fill: "#FFE4DB"
      }), /*#__PURE__*/React.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M39.32 130.342l18.405-2.908-1.646-17.134-16.992 4.94.233 15.102z",
        fill: "#FCC8BD"
      }), /*#__PURE__*/React.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M49.849 111.011s4.532-.902 13.288-2.861c6.315-1.413 12.246-1.567 20.782-1.907l39.845-1.945s9.724-1.403 11.141 5.401C136.323 116.501 136 193 136 193H74.5l-7.608-47.081-21.287.4.886-32.185 3.358-3.123z",
        fill: "#CCD5FF"
      }), /*#__PURE__*/React.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M101.754 73.994c.721 2.371-.458 4.83-2.632 5.49-2.174.66-4.52-.728-5.24-3.099-.72-2.37.459-4.829 2.633-5.489 2.174-.66 4.519.727 5.239 3.098z",
        fill: "#242F57"
      }), /*#__PURE__*/React.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M100.912 78.353c2.009 6.616-1.726 13.607-8.34 15.616-6.617 2.009-13.608-1.724-15.617-8.341-1.004-3.307-3.098-6.414-1.589-9.24 1.51-2.826 6.622-5.371 9.93-6.376 6.615-2.01 13.607 1.726 15.616 8.34z",
        fill: "#242F57"
      }), /*#__PURE__*/React.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M107.095 107.378l-17.404 3.111-5.265-17.337 16.8-5.101 5.869 19.327z",
        fill: "#FFE4DB"
      }), /*#__PURE__*/React.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M87.17 102.189l18.258-.303-3.432-11.3-16.8 5.102 1.974 6.501z",
        fill: "#FCC8BD"
      }), /*#__PURE__*/React.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M76.262 86.386a4.425 4.425 0 102.571 8.465 4.424 4.424 0 10-2.571-8.465zM101.727 78.653a4.423 4.423 0 102.571 8.465 4.423 4.423 0 10-2.571-8.465z",
        fill: "#FFE8E0"
      }), /*#__PURE__*/React.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M103.099 81.268c1.933 6.363-1.874 13.153-8.502 15.166s-13.567-1.515-15.5-7.878c-1.932-6.363 1.875-13.153 8.502-15.166 6.628-2.013 13.567 1.515 15.5 7.878z",
        fill: "#FFE8E0"
      }), /*#__PURE__*/React.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M98.706 86.947l-3.089.938-.872-8.427 3.961 7.49z",
        fill: "#FFC2B8"
      }), /*#__PURE__*/React.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M102.946 83.998a.278.278 0 01-.251-.486l2.759-2.129a.276.276 0 01.39.051.277.277 0 01-.049.39l-2.76 2.128a.252.252 0 01-.089.046z",
        fill: "#FCC8BD"
      }), /*#__PURE__*/React.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M91.356 88.009c.318 1.049-.656 2.272-2.176 2.734-1.521.46-3.011-.013-3.329-1.062-.319-1.048.655-2.272 2.176-2.734 1.52-.461 3.011.014 3.329 1.062zM102.217 82.639c-1.521.46-2.495 1.686-2.177 2.733.319 1.048 1.809 1.524 3.329 1.062.033-.01.064-.022.095-.032a11.593 11.593 0 00-.069-3.938 3.956 3.956 0 00-1.178.175z",
        fill: "#FF9094"
      }), /*#__PURE__*/React.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M79.843 91.014a.246.246 0 01-.115.01l-4.31-.538a.278.278 0 11.07-.552l4.31.538a.278.278 0 01.045.542z",
        fill: "#FCC8BD"
      }), /*#__PURE__*/React.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M92.912 67.7a5.91 5.91 0 11-11.31 3.434 5.91 5.91 0 013.938-7.372 5.909 5.909 0 017.372 3.937z",
        fill: "#4C4C4C"
      }), /*#__PURE__*/React.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M86.512 71.804a6.985 6.985 0 11-13.367 4.058 6.985 6.985 0 0113.367-4.058z",
        fill: "#242F57"
      }), /*#__PURE__*/React.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M73.675 70.82s-1.995-7.783 5.996-6.287c7.991 1.496 7.033-6.295 12.181-4.269 5.15 2.026 5.204-5.973 10.854-4.24 5.65 1.733 2.393 13.106-3.838 16.993l-21.752-1.062-3.44-1.136z",
        fill: "#242F57"
      }), /*#__PURE__*/React.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M77.67 85.411l2.807 5.394a1.046 1.046 0 001.964-.63l-1.144-8.038s.015-4.053 4.411-4.54c4.395-.487 4.562-6.469 11.032-4.166l4.102-2.439-15.547-.98s-6.883 8.71-6.819 9.198c.064.487-.807 6.201-.807 6.201z",
        fill: "#242F57"
      }), /*#__PURE__*/React.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M20.192 128.741c-2.401-2.615-2.217-6.614.41-8.883l29.662-25.413 2.176-1.987a1.87 1.87 0 00.188-.199l2.606-3.233 3.749-4.36c.204-.25.436-.522.703-.817l.164-.19.027-.019c4.1-4.495 6.538-5.925 7.709-6.379a1.91 1.91 0 011.403.01l2.499 1.007 4.723 1.792c1.04.382 1.592 1.518 1.23 2.536-.36 1.02-1.531 1.625-2.572 1.243l-4.245-1.55 5.123 1.866c.074.027.146.057.216.093 1.236.62 1.306 2.361.19 3.126-.511.351-1.174.67-1.713.471l-2.375-.777c-.851-.278-1.768.067-2.197.826l-3.318 5.877a1.713 1.713 0 00-.12.262c-.295.811-2.028 5.162-5.867 7.133-.138.07-.267.155-.382.257-1.74 1.564-16.233 14.586-21.086 19.139",
        fill: "#FFE4DB"
      }), /*#__PURE__*/React.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M20.049 128.873c-1.216-1.324-1.83-3.024-1.729-4.787a6.205 6.205 0 012.155-4.375l29.661-25.414 2.172-1.984c.06-.054.117-.114.167-.177l2.608-3.233 3.753-4.364c.208-.257.447-.534.705-.82l.202-.224c4.18-4.58 6.663-5.986 7.771-6.416a2.099 2.099 0 011.547.012l2.5 1.007 4.72 1.79c1.137.418 1.741 1.666 1.345 2.784a2.265 2.265 0 01-1.562 1.42 1.968 1.968 0 011.07 1.633 2.013 2.013 0 01-.87 1.82c-.748.514-1.385.68-1.891.494l-2.37-.774c-.757-.248-1.584.061-1.965.736l-3.317 5.877a1.552 1.552 0 00-.106.231c-.313.86-2.07 5.243-5.962 7.241a1.531 1.531 0 00-.34.229c-1.65 1.481-16.245 14.596-21.085 19.136l-.267-.285c4.843-4.543 19.442-17.661 21.09-19.142.12-.107.262-.204.422-.286 3.764-1.932 5.47-6.192 5.775-7.026.037-.104.081-.202.132-.29l3.319-5.877c.472-.836 1.493-1.222 2.427-.916l2.374.777c.483.177 1.106-.146 1.544-.447.48-.329.74-.879.7-1.472a1.577 1.577 0 00-1.064-1.402l-.74-.27a1.847 1.847 0 01-.138-.046l-4.246-1.55.136-.368.003.001 4.365 1.591c.401.112.834.074 1.231-.112.454-.213.806-.597.966-1.053.326-.918-.174-1.942-1.114-2.288l-4.724-1.793-2.504-1.008a1.704 1.704 0 00-1.26-.01c-1.075.417-3.498 1.794-7.633 6.33l-.188.204c-.258.285-.492.557-.7.812l-3.752 4.364-2.602 3.23a2.059 2.059 0 01-.209.22l-2.175 1.986-29.666 25.418a5.82 5.82 0 00-2.02 4.101c-.096 1.657.482 3.255 1.627 4.501l-.288.264z",
        fill: "#F8AB9F"
      }), /*#__PURE__*/React.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M55.534 97.526c-.02-.012-.033-.02-.039-.022l.197-.338c.023.015 2.575 1.473 4.635.647 1.078-.433 1.846-1.419 2.284-2.934l1.633-5.647.29-1.135c.14-.55.543-1 1.077-1.203 1.575-.597 2.451-.926 2.604-.98l.358-.127 4.24 1.331-.118.372-4.115-1.29-.234.082c-.149.053-1.046.39-2.596.977a1.362 1.362 0 00-.838.935l-.29 1.142-1.636 5.652c-.473 1.637-1.32 2.71-2.515 3.188-2.119.85-4.586-.455-4.937-.65zM62.79 84.284l-.228-.317 3.169-2.275c.043-.034 1.253-.926 5.431.595l-.134.367c-3.917-1.427-5.054-.655-5.065-.647l-3.173 2.277z",
        fill: "#F8AB9F"
      }), /*#__PURE__*/React.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M66.892 145.919l-3.008-13.611-17.923.484-.356 13.526 21.287-.399z",
        fill: "#AAB6F2"
      }), /*#__PURE__*/React.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M89.339 108.787l11.198 9.74 6.143-13.188-17.341 3.448z",
        fill: "#FFE4DB"
      }), /*#__PURE__*/React.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M88.302 105.917l-4.383.326 7.854 24.975 8.764-12.691-12.235-12.61zM100.537 118.527l11.409 8.214-.897-21.822-4.632.226-5.88 13.382z",
        fill: "#5266CC"
      }), /*#__PURE__*/React.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M131.897 105.55l34.096 19.966-30.15 21.688-3.946-41.654z",
        fill: "#CCD5FF"
      }), /*#__PURE__*/React.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M135.844 147.204l-.178-19.728 9.389 13.102-9.211 6.626z",
        fill: "#AAB6F2"
      }), /*#__PURE__*/React.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M172.545 101.25l-18.646 3.163 8.567 50.389a8.046 8.046 0 009.277 6.583l2.783-.472a8.045 8.045 0 006.586-9.28l-8.567-50.383zM153.607 81.688a3.134 3.134 0 00-2.615 3.565l1.652 10.552a3.136 3.136 0 003.564 2.614 3.134 3.134 0 002.615-3.565L157.17 84.3a3.134 3.134 0 00-3.563-2.613z",
        fill: "#FFE4DB"
      }), /*#__PURE__*/React.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M160.018 80.757l-.92.156a2.668 2.668 0 00-2.177 3.07l1.103 6.47a2.668 2.668 0 003.066 2.174l.92-.156a2.666 2.666 0 002.177-3.068l-1.103-6.47a2.668 2.668 0 00-3.066-2.176z",
        fill: "#FFE4DB"
      }), /*#__PURE__*/React.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M165.764 79.122l-.916.177a2.665 2.665 0 00-2.106 3.117l2.481 12.812a2.668 2.668 0 003.116 2.106l.916-.177a2.668 2.668 0 002.107-3.117l-2.483-12.813a2.667 2.667 0 00-3.115-2.105z",
        fill: "#FFE4DB"
      }), /*#__PURE__*/React.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M161.804 86.062l-2.783.472c-4.364.74-7.327 4.917-6.585 9.28l1.74 10.229c.742 4.361 4.916 7.323 9.277 6.583l2.784-.472c4.364-.74 7.327-4.917 6.585-9.281l-1.741-10.23c-.742-4.36-4.917-7.321-9.277-6.581z",
        fill: "#FFE4DB"
      }), /*#__PURE__*/React.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M161.278 98.195a5.67 5.67 0 01-.847 7.976 5.677 5.677 0 01-7.979-.849c-.041-.051-.075-.105-.114-.156-.022-.025-.047-.043-.068-.069l-6.242-7.72a3.132 3.132 0 01.467-4.393 3.136 3.136 0 014.396.467l2.875 3.556a5.678 5.678 0 017.512 1.188z",
        fill: "#FFE4DB"
      }), /*#__PURE__*/React.createElement("path", {
        d: "M157.079 84.734l-.059-.344a3.135 3.135 0 012.558-3.605h.002c1.693-.287 3.047.832 3.335 2.526l.209 1.225M153.605 81.688h.001a3.13 3.13 0 013.007 1.267M152.552 95.206c-.005.097-.004.194-.005.292l-1.655-2.048a3.137 3.137 0 00-4.397-.467 3.131 3.131 0 00-.466 4.394l6.242 7.72c.02.025.046.044.067.068.039.052.073.105.114.156a5.623 5.623 0 001.856 1.494l4.1 24.12 3.452 21.047M157.989 90.118l-1.333-7.038",
        stroke: "#EBAEA2",
        strokeWidth: 0.5,
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }), /*#__PURE__*/React.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M132.908 79.574c.099-.587-.222-1.136-.76-1.39a4.492 4.492 0 01-2.309-5.547c.187-.537.093-1.129-.298-1.542l-.037-.04c-.754-.794-2.08-.508-2.451.522a7.474 7.474 0 003.712 9.234c.884.436 1.978-.072 2.114-1.049.008-.062.018-.125.029-.188z",
        fill: "#B4C3F6"
      }), /*#__PURE__*/React.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M140.695 81.064c-3.843 3.647-9.914 3.489-13.561-.353-3.646-3.843-3.488-9.915.355-13.561 3.843-3.648 9.914-3.488 13.56.353 3.647 3.844 3.489 9.915-.354 13.561zm-15.639-16.477c-5.257 4.99-5.475 13.297-.485 18.555 4.99 5.258 13.299 5.477 18.557.486 5.257-4.99 5.475-13.299.485-18.556-4.99-5.259-13.299-5.476-18.557-.486z",
        fill: "#5266CC"
      }), /*#__PURE__*/React.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M158.88 101.916l.212-.183c.826-.71.921-1.956.211-2.783l-15.169-17.652a1.972 1.972 0 00-2.782-.21l-.213.182a1.973 1.973 0 00-.21 2.783l15.168 17.652a1.974 1.974 0 002.783.211z",
        fill: "#5266CC"
      }), /*#__PURE__*/React.createElement("path", {
        d: "M181.017 151.069l-1.926-11.325-.045-.959-6.501-37.535-1.227-7.218-.014-.06a2.944 2.944 0 00-.05-.444l-2.308-11.78a3.135 3.135 0 00-3.661-2.476l-.002.001a3.132 3.132 0 00-2.369 2.083M159.832 80.79l-.549.092a2.856 2.856 0 00-2.331 3.286l1.04 6.1a2.857 2.857 0 003.284 2.328l.548-.093c1.545-.263 2.425-1.673 2.161-3.218",
        stroke: "#EBAEA2",
        strokeWidth: 0.5,
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }), /*#__PURE__*/React.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M153.607 81.688a3.134 3.134 0 00-2.615 3.565l1.652 10.552a3.136 3.136 0 003.564 2.614 3.134 3.134 0 002.615-3.565L157.17 84.3a3.134 3.134 0 00-3.563-2.613z",
        fill: "#FFE4DB"
      }), /*#__PURE__*/React.createElement("path", {
        clipRule: "evenodd",
        d: "M165.764 79.122l-.916.177a2.667 2.667 0 00-2.106 3.118l1.404 7.242a2.668 2.668 0 003.116 2.106l.916-.177a2.669 2.669 0 002.107-3.118l-1.405-7.244a2.668 2.668 0 00-3.116-2.104zM153.607 81.688v0a3.134 3.134 0 00-2.615 3.565l1.652 10.552a3.136 3.136 0 003.564 2.614 3.134 3.134 0 002.615-3.565L157.17 84.3a3.134 3.134 0 00-3.563-2.613z",
        stroke: "#EBAEA2",
        strokeWidth: 0.5,
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }), /*#__PURE__*/React.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M57.64 45.234c4.155 8.648.512 19.028-8.137 23.183-8.65 4.155-19.03.511-23.183-8.137-4.156-8.65-.512-19.028 8.137-23.184 8.649-4.154 19.028-.51 23.183 8.138z",
        fill: "#768FF4"
      }), /*#__PURE__*/React.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M42.302 58.224c.274-.035.553-.011.816.073.517.165.956.513 1.235.977.14.237.23.502.26.775a1.93 1.93 0 01-.074.817 2.21 2.21 0 01-.976 1.237 1.96 1.96 0 01-.778.26 1.92 1.92 0 01-.816-.075 2.252 2.252 0 01-1.235-.978 1.934 1.934 0 01-.26-.777 1.93 1.93 0 01.074-.815c.165-.516.512-.955.977-1.234.237-.142.503-.231.777-.26zM41.206 43.26c1.586-.185 2.882.106 3.885.872 1.007.767 1.605 1.959 1.794 3.576a4.303 4.303 0 01-.3 2.18c-.29.693-.77 1.465-1.442 2.315-.338.406-.66.825-.962 1.257a4.9 4.9 0 00-.51.904c-.105.26-.164.513-.176.756-.012.242-.001.514.035.815.118 1.015-.25 1.572-1.107 1.672a3.496 3.496 0 01-.793.022.823.823 0 01-.47-.2.939.939 0 01-.257-.452 4.725 4.725 0 01-.132-.718c-.19-1.617.447-3.331 1.907-5.14.338-.412.61-.753.82-1.027.21-.273.369-.525.479-.755.104-.21.168-.438.187-.673a4.232 4.232 0 00-.031-.78c-.083-.713-.361-1.235-.834-1.565-.473-.331-1.09-.451-1.851-.363-.76.089-1.346.378-1.754.868a2.284 2.284 0 00-.553 1.668c.062.94-.343 1.462-1.215 1.564-.92.107-1.433-.291-1.54-1.194-.15-1.301.222-2.518 1.118-3.651.882-1.116 2.117-1.765 3.702-1.951z",
        fill: "#fff"
      }), /*#__PURE__*/React.createElement("path", {
        d: "M151.334 148.309l12.524 9.818c2.431 2.237 4.748 3.79 7.885 3.258l2.783-.472a8.046 8.046 0 006.586-9.281l-1.015-5.97",
        stroke: "#EBAEA2",
        strokeWidth: 0.5,
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }), /*#__PURE__*/React.createElement("path", {
        d: "M158.435 193H40.591",
        stroke: "#5266CC",
        strokeWidth: 0.5,
        strokeLinecap: "round"
      }));
    }
  }]);

  return IconEmptyPic;
}(React.Component);

IconEmptyPic.defaultProps = {
  isIcon: true,
  prefixCls: "arco"
};
export default IconEmptyPic;